<template>
  <div class="reference__accordion">
    <div class="accordion__item accordion__item--main" @click="toggleGlossary">
      <div class="accordion__item-wrapper">
        <p class="accordion__title bold">Глоссарий</p>
        <img
          class="accordion__icon--down"
          src="../../../assets/icons/arrow-down.svg"
          alt=""
          :class="{ 'accordion__item--open': glossaryVisible }"
        />
      </div>
    </div>
    <div
      class="accordion__item accordion__item--sub accordion__item--readOnly"
      v-if="glossaryVisible"
    >
      <p class="paragraph">
        <span class="text--blue bold">
          Банк
        </span>
        – Банки второго уровня, имеющие статус «действующий» на момент выгрузки
        данных. В случае, если банк был ликвидирован в текущем портфеле его
        займы не отражаются, но в исторических отчетах (когда БВУ был в статусе
        «действующий») его займы будут также отражаться.
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Demo
        </span>
        – тестовые данные для демонстрации возможностей модуля визуальной
        аналитики FCB Visual Analytics. Не отражают реальной картины на рынке
        кредитования и не могут использоваться пользователями для какого-либо
        анализа и выводов.
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Выданные кредиты
        </span>
        - кредитные контракты с датой открытия в заданный период (месяц,
        квартал, год). К выданным займам также относятся изменения внутри
        кредитных линий, которые могут расцениваться как новый заем. Расширенную
        методологию можно обсудить с аналитиками ПКБ.
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Винтаж
        </span>
        - анализ качества кредитных портфелей по поколениям выдач
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Действующий кредит
        </span>
        – кредитный контракт, по которому на отчетную дату имеются неисполненные
        обязательства по погашению задолженности
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          ИП (Индивидуальный предприниматель)
        </span>
        - физическое лицо, зарегистрированное в установленном законом порядке и
        осуществляющее предпринимательскую деятельность без образования
        юридического лица. Статус ИП в отчетности отражается из переданной
        поставщиками информации.
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Кредитный портфель
        </span>
        — это совокупная задолженность всех заемщиков перед кредитором,
        включающая сумму непогашенной задолженности, сумму просроченной
        задолженности, а также начисленное вознаграждение за ближайший платеж.
        Есть возможность посмотреть фактический кредитный портфель и кредитный
        портфель с включением списанных за баланс кредитов.
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Кредитная нагрузка
        </span>
        - показатель, отражающий среднее значение количества/суммы кредитов на
        одного заемщика.
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Количество кредитов
        </span>
        - совокупное количество действующих кредитных контрактов заемщиков на
        дату получения/формирования отчета
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Количество заемщиков
        </span>
        - совокупное количество заемщиков с действующими кредитными  контрактами.
        Заемщиков может быть меньше контрактов.
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Новый заемщик
        </span>
        - физическое или юридическое лицо, которое впервые оформило кредитный
        договор (ранее не имевший кредитной истории), в заданный расчётный
        период
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Рынок
        </span>
        - совокупность финансовых институтов, осуществляющих кредитование
        физических и юридических лиц на территории РК и предоставляющее
        информацию в кредитное бюро.
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Срез
        </span>
        - информация, предоставленная финансовыми организациями (БВУ, МФО, МКО и
        другими поставщиками информации) в соответствии с законодательством РК в
        течение 15 рабочих дней с даты изменения или получения любых данных в
        отношении субъекта кредитной истории. Данная информация может отличаться
        от бухгалтерских показателей.
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Субъект (заемщик)
        </span>
        - физическое или юридическое лицо, в отношении которого формируется
        кредитная история. В отчетах субъектов может быть меньше, чем кредитных
        контрактов.
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Сумма ссудной задолженности
        </span>
        - cумма денег, которую заемщик получил от финансового института, но еще
        не вернул согласно условиям, которые оговорены в кредитном контракте.
        Совокупная сумма ссудной задолженности состоит из суммы основного долга
        и начисленного, но еще не выплаченного вознаграждения по кредитному
        контракту
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          FPD
        </span>
        -(First payment default) -дефолт первых трех платежей – кредит с
        дефолтом 1-го, 2-го и 3-го платежей, как правило характеризующий
        мошенничество.
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          NPL
        </span>
        - (Non-performing loan) – неработающий кредит, т.е. кредит, по которому
        выплата процентов и непогашенной задолженности просрочена на заданное в
        отчете количество дней (NPL1+, NPL 15+, NPL 30+, NPL 60+, NPL 90+)
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          SPD
        </span>
        - (Second payment default) - дефолт второго и третьего платежа – кредит
        с дефолтом 2-го и 3-го платежа, при этом 1-ый платеж был внесен без
        просрочки
      </p>
    </div>
  </div></template
>

<script>
export default {
  data() {
    return {
      glossaryVisible: false,
    };
  },
  methods: {
    toggleGlossary() {
      this.glossaryVisible = !this.glossaryVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
.reference {
  margin-bottom: 12.6rem;
  &__accordion {
    background: #f1f9ff;
    &:nth-child(even) {
      background-color: transparent;
    }
  }
  &__wrapper {
    max-width: 1110px;
    width: 100%;
    padding: 0 45px;
    margin: auto;
    &__cuttext {
      width: 100%;
    }
  }
}
.accordion {
  &__item {
    padding: 2rem;
    //height: 6.3rem;
    cursor: pointer;
    &--readOnly {
      cursor: auto;
    }
    &--open {
      transform: rotate(180deg);
    }
    &-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
    &--sub {
      height: auto;
      border-top: 1px solid rgba(0, 0, 0, 0.2);
      padding-left: 8rem;
      font-size: 16px;
    }
    &--main {
    }
  }
  &__icon {
    width: 3rem;
    height: 3rem;
    &--down {
    }
  }
  &__title {
    color: #005177;
    font-size: 14px;
    display: flex;
    align-items: center;
    &--secondary {
      margin-left: 3.1rem;
      width: 100%;
      font-size: 16px;
    }
  }
}
</style>
